/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

/// <reference types="webpack-env" />

import { registerLocaleData } from '@angular/common';
import RequireContext = __WebpackModuleApi.RequireContext;

function importAllLocaleData(r: RequireContext): void {
  r.keys()
    .filter((key) => !key.includes('extra'))
    .filter((key) => !key.includes('global'))
    // load all basic and extra locale data
    .forEach((key) => registerLocaleData(r(key).default, r(key.replace(/(\/[^/]+)$/, '/extra$1')).default));
}

// LOCALES_CONTEXT_FILTER is a filter for set of files for allowed locales
const localesFilter = process.env.LOCALES_CONTEXT_FILTER;
const filterRegex = localesFilter ? new RegExp(localesFilter) : /.*/;

const localeContext = require.context('../../../node_modules/@angular/common/locales', true, /\.mjs$/);

const filteredKeys = localeContext.keys().filter((key) => {
  return filterRegex.test(key);
});

const filteredContext = Object.assign(
  (key: string) => localeContext(key),
  {
    keys: () => filteredKeys,
  }
) as RequireContext;

importAllLocaleData(filteredContext);
